import React, { useEffect, useState } from "react";
import { getCompanyConfig, updateCompanyConfig } from "../api/companyConfig";
import { Divider, Skeleton, Button, message } from "antd";
import { Input } from "antd";
import { DeleteOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";

const GeneralConfig = () => {
  const [company, setCompany] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const [loading, setLoading] = useState(false);
  const [newConfigKeyGeneral, setNewConfigKeyGeneral] = useState("");
  const [newConfigKeyDefontana, setNewConfigKeyDefontana] = useState("");

  useEffect(() => {
    const getCompanyOnLoaded = async () => {
      const company = await getCompanyConfig();
      setCompany(company);
    };
    getCompanyOnLoaded();
  }, [refresh]);

  const handleConfigUpdate = async (type, key, value) => {
    const newCompany = {
      ...company,
      [type]: { ...company[type], [key]: value },
    };
    setCompany(newCompany);
  };

  const handleUpdate = async (newCompany = null) => {
    // Check if all keys have some value
    const finalCompany = newCompany || company;
    const allKeysHaveValueInternal = Object.keys(
      finalCompany.internal_config
    ).every((key) => key !== "" && key !== undefined);

    const allKeysHaveValueDefontana = Object.keys(
      finalCompany.defontana_config
    ).every((key) => key !== "" && key !== undefined);

    if (!allKeysHaveValueInternal || !allKeysHaveValueDefontana) {
      message.error("Las keys de la configuración deben tener un valor");
      handleUpdate();
      return;
    }

    setLoading(true);
    await updateCompanyConfig(finalCompany);
    newCompany && message.success("Configuración actualizada correctamente");
    setRefresh(!refresh);
    setLoading(false);
  };

  const handleRemoveConfig = (key) => {
    const newCompany = {
      ...company,
      internal_config: { ...company.internal_config, [key]: undefined },
    };
    setCompany(newCompany);
    handleUpdate(newCompany);
  };

  const handleAddConfig = (type) => {
    const newConfigKey =
      type === "internal_config" ? newConfigKeyGeneral : newConfigKeyDefontana;
    const newCompany = {
      ...company,
      [type]: {
        ...company[type],
        [newConfigKey]: "",
      },
    };
    setCompany(newCompany);
    handleUpdate(newCompany);

    setNewConfigKeyGeneral("");
    setNewConfigKeyDefontana("");
  };

  return (
    <div>
      <div className="font-bold text-3xl">Información de la Empresa</div>
      <div className="flex flex-col gap-2">
        <div>
          <span className="text-gray-500">Nombre de la empresa: </span>
          <span className="">{company?.name || <Skeleton.Input active />}</span>
        </div>
        <div>
          <span className="text-gray-500">Descripción: </span>{" "}
          <span className="">
            {company?.description || <Skeleton.Input active />}
          </span>
        </div>
        <div></div>
      </div>
      <Divider />

      <div className="flex flex-col gap-10">
        {/* Internal Config */}
        <div>
          <h2 className="text-lg font-bold">Configuración General</h2>
          {company ? (
            Object.keys(company.internal_config).map((key) => (
              <div className="flex flex-row justify-between gap-2 items-center mt-2">
                <div key={key} className="flex flex-row gap-2 items-center">
                  <div className="text-gray-500">{key}: </div>
                  <Input
                    disabled={loading}
                    value={company.internal_config[key]}
                    onChange={(e) =>
                      handleConfigUpdate("internal_config", key, e.target.value)
                    }
                    className="max-w-sm"
                  />
                </div>
                <div className="flex flex-row gap-2">
                  <Button
                    onClick={() => handleUpdate()}
                    loading={loading}
                    type="text"
                    icon={<SaveOutlined />}
                  >
                    Actualizar
                  </Button>
                  <Button
                    onClick={() => handleRemoveConfig(key)}
                    type="text"
                    danger
                  >
                    <DeleteOutlined /> Eliminar
                  </Button>
                </div>
              </div>
            ))
          ) : (
            <Skeleton />
          )}
          <div className="mt-4 flex flex-row items-center justify-between">
            <Input
              value={newConfigKeyGeneral}
              onChange={(e) => setNewConfigKeyGeneral(e.target.value)}
              className="max-w-xs"
            />
            <Button
              onClick={() => handleAddConfig("internal_config")}
              type="dashed"
            >
              <PlusOutlined />
            </Button>
          </div>
        </div>

        {/* Defontana Config */}
        <div>
          <h2 className="text-lg font-bold">Configuración Defontana</h2>
          {company ? (
            Object.keys(company.defontana_config).map((key) => (
              <div className="flex flex-row justify-between gap-2 items-center mt-2">
                <div key={key} className="flex flex-row gap-2 items-center">
                  <div className="text-gray-500">{key}: </div>
                  <Input
                    disabled={loading}
                    value={company.defontana_config[key]}
                    onChange={(e) =>
                      handleConfigUpdate(
                        "defontana_config",
                        key,
                        e.target.value
                      )
                    }
                    className="max-w-sm"
                  />
                </div>
                <div className="flex flex-row gap-2">
                  <Button
                    onClick={() => handleUpdate()}
                    loading={loading}
                    type="text"
                    icon={<SaveOutlined />}
                  >
                    Actualizar
                  </Button>
                  <Button
                    onClick={() => handleRemoveConfig(key)}
                    type="text"
                    danger
                  >
                    <DeleteOutlined /> Eliminar
                  </Button>
                </div>
              </div>
            ))
          ) : (
            <Skeleton />
          )}
          <div className="mt-4 flex flex-row items-center justify-between">
            <Input
              value={newConfigKeyDefontana}
              onChange={(e) => setNewConfigKeyDefontana(e.target.value)}
              className="max-w-xs"
            />
            <Button
              onClick={() => handleAddConfig("defontana_config")}
              type="dashed"
            >
              <PlusOutlined />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralConfig;
